<template>
  <div class="login-page">
    <div class="overlay"></div>
    <div class="login-wrapper">
      <h2 class="title">椅旁数字化预约</h2>
      <form class="login-form" @submit.prevent="handleLogin">
        <div class="input-item">
          <span class="icon">👤</span>
          <input
            v-model.trim="form.username"
            type="text"
            placeholder="请输入账号"
            autocomplete="username"
          />
        </div>
        <div class="input-item">
          <span class="icon">🔒</span>
          <input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            autocomplete="current-password"
          />
        </div>
        <div class="options-row">
          <label class="remember-me">
            <input v-model="form.rememberMe" type="checkbox" />
            <span>记住账号</span>
          </label>
        </div>
        <button class="login-btn" type="submit" :disabled="loading">
          {{ loading ? "登录中..." : "登录" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { login } from "../api/auth";
import {
  extractTokenFromResponse,
  extractUserFromResponse,
  setToken,
  setUserInfo,
} from "../api/token";

export default {
  name: "LoginPage",
  data() {
    return {
      loading: false,
      form: {
        username: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    async handleLogin() {
      if (!this.form.username || !this.form.password) {
        this.showMessage("warning", "请输入账号和密码");
        return;
      }

      this.loading = true;
      try {
        const res = await login({
          phone: this.form.username,
          password: this.form.password,
          rememberMe: this.form.rememberMe,
        });

        if (res && res.code === 41020) {
          this.showMessage("error", res.msg || "登录失败，账号或密码错误");
          return;
        }

        const token = extractTokenFromResponse(res);
        if (!token) {
          this.showMessage("error", "登录成功但未返回 token，请联系管理员");
          return;
        }

        setToken(token);
        setUserInfo(extractUserFromResponse(res));
        this.$emit("login-success", res || {});
      } catch (error) {
        const msg =
          (error && error.code === 40016 && (error.msg || error.message)) ||
          error.message ||
          "登录失败，请稍后重试";
        this.showMessage("error", msg);
      } finally {
        this.loading = false;
      }
    },
    showMessage(type, text) {
      if (this.$message && this.$message[type]) {
        this.$message[type](text);
      } else {
        alert(text);
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("https://images.unsplash.com/photo-1583911860205-72f8ac8ddcbe?auto=format&fit=crop&w=1920&q=80")
    center center / cover no-repeat;
  overflow: hidden;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(120, 170, 220, 0.45);
}

.login-wrapper {
  position: relative;
  z-index: 1;
  width: 360px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 8px;
  padding: 24px 22px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.title {
  margin: 0 0 20px;
  text-align: center;
  font-size: 20px;
  color: #2f3b4c;
}

.input-item {
  display: flex;
  align-items: center;
  border: 1px solid #d7dce6;
  border-radius: 4px;
  margin-bottom: 14px;
  background: #fff;
}

.icon {
  display: inline-flex;
  width: 36px;
  justify-content: center;
  color: #95a0af;
  font-size: 14px;
}

.input-item input {
  width: 100%;
  height: 38px;
  border: none;
  outline: none;
  padding-right: 10px;
  font-size: 14px;
  color: #374152;
}

.options-row {
  margin: 8px 0 16px;
  font-size: 13px;
  color: #6f7d90;
}

.remember-me {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.login-btn {
  width: 100%;
  height: 38px;
  border: none;
  border-radius: 4px;
  background: #409eff;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.login-btn:disabled {
  background: #8bbcf2;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .login-wrapper {
    width: calc(100% - 24px);
    max-width: 360px;
    padding: 18px 16px;
  }

  .title {
    font-size: 18px;
    margin-bottom: 16px;
  }
}
</style>
